// RFC 7636 PKCE helpers for the SPA. The code_verifier is a high-entropy
// random string; the code_challenge is its SHA-256 hash, base64url-encoded.
// We persist the verifier in sessionStorage so the /auth/callback page can
// finish the exchange after the WorkOS round-trip.

const VERIFIER_KEY = 'skillsou.auth.code_verifier';
const STATE_KEY = 'skillsou.auth.state';

function bufferToBase64Url(buf: ArrayBuffer): string {
  const bytes = new Uint8Array(buf);
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function generateCodeVerifier(): string {
  // 32 random bytes → 43-char base64url string (the lower bound of PKCE spec).
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  return bufferToBase64Url(bytes.buffer);
}

export async function deriveCodeChallenge(verifier: string): Promise<string> {
  const data = new TextEncoder().encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return bufferToBase64Url(digest);
}

export function rememberVerifier(verifier: string, state: string): void {
  sessionStorage.setItem(VERIFIER_KEY, verifier);
  sessionStorage.setItem(STATE_KEY, state);
}

export function takeRememberedVerifier(state: string): string | null {
  const expectedState = sessionStorage.getItem(STATE_KEY);
  const verifier = sessionStorage.getItem(VERIFIER_KEY);
  sessionStorage.removeItem(VERIFIER_KEY);
  sessionStorage.removeItem(STATE_KEY);
  if (!verifier || expectedState !== state) return null;
  return verifier;
}
